import { ITableMessage } from 'dromo-uploader-js'

export function validateNumberMinMax(
  value: string,
  min: number,
  max: number
): ITableMessage[] {
  if (!value) {
    return []
  }
  const parsedValue = parseFloat(value)
  if (parsedValue >= min && parsedValue <= max) {
    return []
  }
  return [
    {
      message: `Invalid number. Expecting number between ${min} and ${max}`,
      level: 'error',
    },
  ]
}
